export default class PaAttnGroupLineController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroupLine/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroupLine/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paAttnGroupLine/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroupLine/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroupLine/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroupLine/delete', 'post', params, axiosOption, httpOption);
  }
}
